import React from "react";
import "./index.scss";
import sessionExpiredLogo from "../../../Assests/Images/sessionExpiredLogo.svg";
import Logo from "../../../Assests/Images/Logo.svg";
import Button from "../../../SharableInputs/Button";
import { useNavigate } from "react-router-dom";

const SessionExpired = () => {
  const navigate = useNavigate();
  return (
    <div className="login-wrapper">
      <div className="sm-row login-container d-lg-flex d-md-flex justify-content-between position-absolute fixed-bottom h-100">
        <div className="col-lg-6 col-md-6 col-sm-12 left-container text-center overflow-hidden align-content-end">
          <img
            className="login-img"
            src={sessionExpiredLogo}
            alt="session expired logo"
          />
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 right-container d-flex">
          <div className="form-container d-flex flex-column justify-content-around p-4 col-10">
            <div>
              <img src={Logo} alt="canary logo" />
            </div>
            <div className="form-feilds main-content">
              <h1 className="form-header header-text fw-bold mb-3 lh-1">
                Session Expired
              </h1>
              <div>
                <p className="help-text">
                  Your session has expired. If you have trouble logging in,
                  please click the login button below.
                </p>
                <p className="help-text">
                  If you’re still unable to access your account, contact HR
                  support at <span className="help-link">help@i9.com</span>
                </p>
              </div>
              <div className="action-button-container d-flex flex-row-reverse align-items-center align-self-end">
                <Button
                  type="button"
                  label="Go to login"
                  primary={true}
                  onClick={() => navigate("/")}
                  className="action-button align-self-end"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionExpired;
